import InfoArea from "@core-components/info-area/InfoArea";
import SSHeadline from "@core-components/title/SSHeadline";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { SimpleGrid, Stack } from "@mantine/core";
import { Fragment } from "react/jsx-runtime";

const SSReasons: React.FC = () => {
  const { t } = useAppTranslation("pages.home.reasons");

  const areas = [
    {
      title: t("items.0.title"),
      description: t("items.0.description"),
    },
    {
      title: t("items.1.title"),
      description: t("items.1.description"),
    },
    {
      title: t("items.2.title"),
      description: t("items.2.description"),
    },
    {
      title: t("items.3.title"),
      description: t("items.3.description"),
    },
    {
      title: t("items.4.title"),
      description: t("items.4.description"),
    },
    {
      title: t("items.5.title"),
      description: t("items.5.description"),
    },
  ];

  const getInfoArea = (title: string, description: string) => (
    <InfoArea
      hasBorder
      className="!p-6 h-full max-w-[400px]"
      description={description}
      headLine={
        <SSHeadline
          props={{
            title: { order: 3, className: "font-secret-narrow" },
            stack: { align: "left" },
          }}
        >
          <SSWhiteText>{title}</SSWhiteText>
        </SSHeadline>
      }
    />
  );

  return (
    <Stack gap={30}>
      <SSHeadline props={{ title: { fz: 24 } }}>
        <SSWhiteText>{t("title")}</SSWhiteText>
        <SSLoLGradientText>{t("titleLol")}</SSLoLGradientText>
      </SSHeadline>
      <SimpleGrid
        className="px-3"
        cols={{ base: 1, sm: 2, md: 3 }}
        verticalSpacing={"xl"}
      >
        {areas.map((area, index) => (
          <Fragment key={index}>
            {getInfoArea(area.title, area.description)}
          </Fragment>
        ))}
      </SimpleGrid>
    </Stack>
  );
};

export default SSReasons;
